import es from './es';
import it from './it';
import en from './en';
import { getSettings, onSettingsChange } from '../game/systems/settings';

const dictionaries = { es, it, en };

function deepGet(obj, path) {
  return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}

export function t(key) {
  const lang = getSettings().language || 'es';
  const primary = deepGet(dictionaries[lang] || {}, key);
  if (typeof primary === 'string' && primary.length > 0) return primary;
  const fallback = deepGet(dictionaries.es, key);
  return typeof fallback === 'string' ? fallback : key;
}

export function subscribeLanguage(cb) {
  return onSettingsChange((s, prev) => {
    if (prev.language !== s.language) cb(s.language);
  });
}

export const AVAILABLE_LANGUAGES = ['es', 'it', 'en'];
